import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import { homeQueryKeys } from "@/lib/homeQueryCache";
import type { WorkflowOutput } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useWorkflow(params: Params, enabled = true) {
  const query = buildParams(params);

  return useQuery({
    queryKey: [...homeQueryKeys.workflow, params],
    queryFn: () => apiFetch<WorkflowOutput>(`/v1/home/workflow${query}`),
    enabled,
  });
}
